(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-product"]) return;
  try {
    
if (!customElements.get('atelier-variant-ready')) {
  customElements.define('atelier-variant-ready', class extends HTMLElement {});
  document.addEventListener('change', event => {
    if (event.target.matches('[data-edition]')) event.target.form.requestSubmit();
  });
}

  } catch(e) { console.error(e); }
})();
})();
